module.exports = __webpack_public_path__ + "img/secure.d3015e37.png";